import type { GraphQLClient } from 'graphql-request';
import { type ReactNode, createContext, useContext } from 'react';

import { defaultGraphQLClient } from '../client';

const graphQLClientContext = createContext<GraphQLClient | undefined>(undefined);

export function GraphQLClientProvider({
  graphqlClient,
  children,
}: {
  graphqlClient: GraphQLClient;
  children: ReactNode;
}) {
  return (
    <graphQLClientContext.Provider value={graphqlClient}>{children}</graphQLClientContext.Provider>
  );
}

export function useGraphQLClient(): GraphQLClient {
  const client = useContext(graphQLClientContext);
  if (client) return client;

  // eslint-disable-next-line no-console
  console.error(
    'useGraphQLClient should be used within a GraphQLClientProvider, using default fallback',
  );

  return defaultGraphQLClient;
}
